/**
 * @desc OMS包裹创建出库计划单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/createOutPlan`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
